import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import SalesNotification from "./SalesNotification";
export default function App() {
  return <>
      <BrowserRouter data-id="element-0">
        <Routes data-id="element-1">
          <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        </Routes>
      </BrowserRouter>

      {/* Popup de ventas (solo móvil) */}
      <SalesNotification data-id="element-4" />
    </>;
}